import Simplebar from 'simplebar';

export default (function () {
  return {
    init() {
      this.initScrollbar();
    },

    initScrollbar() {
      const scrollbar = document.querySelectorAll('.js-scrollbar');

      scrollbar.forEach((bar) => {
        setTimeout(() => {
          // eslint-disable-next-line no-new
          const customScroll = new Simplebar(bar);
        }, 500);
      });
    },
  };
})();
